import React from 'react';

const Slider = ({left, width, color}) => {
  let sliderStyle = {
    left: left + 'px',
    width: width + 'px',
  }

  if (color !== undefined){
    Object.assign(sliderStyle, {backgroundColor: color});
  }

  return (
    <div className="nav-bar-slider">
      {left !== undefined && width !== undefined &&
        <span className="nav-bar-slider--indicator" style={sliderStyle}></span>
      }
    </div>
  )
};

export default Slider;



// WEBPACK FOOTER //
// ./components/nav-bar/slider.js